module.exports = __webpack_public_path__ + "static/media/Bewerbungsfoto_Olga Zoll.9d0baefc.jpg";